import React, { useId } from "react";
import { getCurrency } from "@/helpers/utils";
import { Money } from "@/helpers/Money";
import { Progress } from "@/components/Progress";

export type ShippingProgressBarProps = {
  cartValue: Money;
  shippingThreshold: number;
  returnTestVariant?: boolean;
};

const getDefaultCompletionText = (distanceToThreshold: number) => (
  <p className="body text-sm font-semibold">
    {distanceToThreshold <= 0
      ? "Your order ships free!"
      : `You’re ${getCurrency(distanceToThreshold)} away from free shipping!`}
  </p>
);

export const ShippingProgressBar = ({
  cartValue,
  shippingThreshold,
  returnTestVariant = false,
}: ShippingProgressBarProps) => {
  const id = useId();
  const cartDollars = cartValue.asDollars();
  const distanceToThreshold = Math.max(0, shippingThreshold - cartDollars);
  const percentComplete = Math.min(
    (cartDollars / shippingThreshold) * 100,
    100
  );
  const defaultCompletionText = getDefaultCompletionText(distanceToThreshold);

  return returnTestVariant ? (
    <div className="[&>div]:h-2">
      <Progress aria-labelledby={id} value={percentComplete} />
    </div>
  ) : (
    <div className="flex h-16 w-full flex-col items-center justify-evenly border-0 border-b border-solid border-primary-200 bg-primary-50">
      <span id={id}>{defaultCompletionText}</span>
      <div className="w-4/5">
        <Progress aria-labelledby={id} value={percentComplete} />
      </div>
    </div>
  );
};
